module.exports = __webpack_public_path__ + "img/cave31.49557b4e.jpg";